import { FREE_SHIPPING_COUNTRIES } from 'lib/constants/localisation';

export const isFreeShippingCountry = (countryCode: string) =>
  FREE_SHIPPING_COUNTRIES.includes(countryCode);
